var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLittleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4,19l3.5,1.8c0.4,0.2,0.9,0.3,1.3,0.1c0.4-0.1,0.8-0.4,1-0.8c0.2-0.4,0.3-0.8,0.3-1.3L17.9,15c0-0.3,0-0.5,0.2-0.7 l2.9-2.8c0.3-0.3,0.5-0.7,0.5-1.2c0-0.4-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.6-1.1-0.6L16,8c-0.3,0-0.5-0.2-0.6-0.5L13.6,4 c-0.2-0.4-0.5-0.7-1-0.9c-0.4-0.2-0.9-0.2-1.3,0c-0.4,0.2-0.8,0.5-1,0.9L8.6,7.5C8.5,7.8,8.3,7.9,8,8L4,8.5C3.6,8.6,3.2,8.8,2.9,9.2 c-0.3,0.3-0.4,0.8-0.4,1.2c0,0.4,0.2,0.9,0.5,1.2l2.9,2.8c0.2,0.2,0.3,0.5,0.2,0.7l-0.7,3.9c-0.1,0.4,0,0.9,0.3,1.3 c0.2,0.4,0.6,0.6,1,0.8c0.4,0.1,0.9,0.1,1.3-0.1l3.5-1.8C11.9,18.8,12.1,18.8,12.4,19L12.4,19z M7.6,20c-0.3,0.1-0.6,0.1-0.9-0.1 c-0.3-0.2-0.4-0.5-0.3-0.8l0.7-3.9c0.1-0.6-0.1-1.2-0.5-1.6l-2.9-2.8c-0.2-0.2-0.3-0.6-0.2-0.9c0.1-0.3,0.4-0.5,0.7-0.6l4-0.6 c0.6-0.1,1.1-0.4,1.3-1l1.8-3.5c0.1-0.3,0.4-0.5,0.8-0.5s0.6,0.2,0.8,0.5l1.8,3.5c0.3,0.5,0.8,0.9,1.3,1l4,0.6 c0.3,0,0.6,0.3,0.7,0.6c0.1,0.3,0,0.6-0.2,0.9l-2.9,2.8c-0.4,0.4-0.6,1-0.5,1.6l0.7,3.9c0.1,0.3-0.1,0.6-0.3,0.8 c-0.3,0.2-0.6,0.2-0.9,0.1l-3.5-1.8c-0.5-0.3-1.1-0.3-1.7,0L7.6,20L7.6,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLittleStar);
export default __webpack_public_path__ + "static/media/icon-little-star.62838178600d7c5f026e1eb35fb8f0ea.svg";
export { ForwardRef as ReactComponent };